import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faEarthAmericas } from '@fortawesome/free-solid-svg-icons';
import { faDiscord } from '@fortawesome/free-brands-svg-icons';

const StatusCard = styled.div`
  background: rgba(10, 10, 10, 0.8);
  border-radius: 16px;
  padding: 2rem;
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-5px);
    border-color: var(--primary-color);
    box-shadow: 0 10px 30px rgba(255, 51, 51, 0.2);
  }
`;

const StatusHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 2rem;
`;

const StatusIcon = styled.div`
  font-size: 1.5rem;
  color: var(--primary-color);
  margin-right: 1rem;
`;

const StatusTitle = styled.h3`
  color: #fff;
  margin: 0;
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
`;

const JoinButton = styled.a`
  display: inline-block;
  background: var(--primary-color);
  color: #fff;
  padding: 0.8rem 2rem;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 600;
  margin-top: 1.5rem;
  transition: all 0.3s ease;
  
  &:hover {
    background: var(--secondary-color);
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(255, 51, 51, 0.3);
  }
`;

const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
  margin-bottom: 1.5rem;
`;

const StatItem = styled.div`
  background: rgba(255, 51, 51, 0.1);
  padding: 1.2rem 2rem;
  border-radius: 12px;
  text-align: left;
  border: 1px solid rgba(255, 51, 51, 0.2);
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  
  &:hover {
    transform: translateY(-3px);
    border-color: var(--primary-color);
    box-shadow: 0 8px 20px rgba(255, 51, 51, 0.2);
  }
`;

const StatLabel = styled.div`
  color: #aaa;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 0.5rem;
`;

const StatContent = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
`;

const StatIcon = styled.div`
  color: var(--primary-color);
  font-size: 1.4rem;
`;

const StatValue = styled.div`
  color: #fff;
  font-size: 1.8rem;
  font-weight: 700;
`;

const DiscordStatus = ({ discordInvite }) => {
  return (
    <StatusCard>
      <StatusHeader>
        <StatusIcon>
          <FontAwesomeIcon icon={faDiscord} />
        </StatusIcon>
        <StatusTitle>Discord Status</StatusTitle>
      </StatusHeader>

      <StatsGrid>
        <StatItem>
          <StatLabel>Members</StatLabel>
          <StatContent>
            <StatIcon>
              <FontAwesomeIcon icon={faUsers} />
            </StatIcon>
            <StatValue>5,000+</StatValue>
          </StatContent>
        </StatItem>
        <StatItem>
          <StatLabel>Online</StatLabel>
          <StatContent>
            <StatIcon>
              <FontAwesomeIcon icon={faEarthAmericas} />
            </StatIcon>
            <StatValue>1,200</StatValue>
          </StatContent>
        </StatItem>
      </StatsGrid>

      <JoinButton href={discordInvite} target="_blank" rel="noopener noreferrer">
        Join Discord
      </JoinButton>
    </StatusCard>
  );
};

export default DiscordStatus;